import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../actions/auth';
import { Navbar } from '../ui/NavBar';
import transEs from '../../translate/es.json';
import transCat from '../../translate/cat.json';
import transDe from '../../translate/de.json';
import transEn from '../../translate/en.json';
import transFr from '../../translate/fr.json';
import transOt from '../../translate/ot.json';
import transPr from '../../translate/pr.json';
import {encode as base64_encode} from 'base-64';
import  { PositionUpdate }  from '../../controllers/PositionUpdate';
import  { positionByCourse }  from '../../controllers/positionByCourse';

// Home to display "Pregunta"
export const FinishScreen = () => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const langTxt = localStorage.getItem('userLanguage') || 'es';
    let transTxt = transEs;
    if(langTxt === 'es'){
        transTxt = transEs;
    }
    else if(langTxt === 'cat'){
        transTxt = transCat;
    }
    else if(langTxt === 'de'){
        transTxt = transDe;
    }
    else if(langTxt === 'en'){
        transTxt = transEn;
    }
    else if(langTxt === 'fr'){
        transTxt = transFr;
    }
    else if(langTxt === 'pr'){
        transTxt = transPr;
    }
    else{
        transTxt = transOt;
    }
    const cursoColor = localStorage.getItem('courseColor');
    const cursoId = localStorage.getItem('courseId');
    const cursoNombre = window.localStorage.getItem(`courseName`);
    const url = `/units/${ cursoId }`;
    let user = useSelector( state => state.auth );
    const token = useSelector((state) => state.ui.token);
    if(!user?.id){
        if(sessionStorage.getItem('userSelect') && token){
            user = JSON.parse(sessionStorage.getItem('userSelect'));
        }
        else{
            dispatch(logout(token));
            history( '/auth/', {
            replace: true
            });
        }
    }
    const [imgBackType, setImgBackType] = useState(false);
    const [imgBack, setImgBack] = useState('');
    const [questionDes, setQuestionDes] = useState('');
    var ran = false;
    useEffect(() => {
        if (ran) return;
        setImgBackType(JSON.parse(window.localStorage.getItem('edufami_feedback_correct')).image_type)
        setImgBack(JSON.parse(window.localStorage.getItem('edufami_feedback_correct')).image_value)
        positionByCourse( token, user.id, cursoId)
        .then((e)=>{
            if(e.status === "Token is Expired"){
                dispatch(logout(token));
            }
            PositionUpdate( token, user.id, cursoId,url, e[0].id)
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
            });
        })
        .catch((e)=>{
            console.error(e);
            // dispatch(logout(token));
        });
        
        setQuestionDes(`¡Felicidades! Has terminado el curso ${ cursoNombre } con éxito`);
        return () => (ran = true);  
    }, [cursoId])

    const handlerClick = (e) => {
        history( url, {
            replace: true
        });
    };
    
    let img_wrong = `${process.env.REACT_APP_PRD_URL}/assets/felicidadesldpi.svg`;
    const disCourse = ()=>{

                return (<>
                    <div className="cont-fail"><img src={img_wrong} alt={cursoNombre} className="finish-answer" /></div>
                    <div className="fin-description" style={{whiteSpace: 'pre-line'}}>
                        <div className="question-fin" style={{whiteSpace: 'pre-line', fontSize: '1.5em'}}>{questionDes}</div>

                        <div className="course-fin">
                            <button id="btnIngresar" tabIndex="0" className="btn m-1 btn-block btn-wfp-main wfp--btn wfp--btn--primary" onClick={handlerClick} style={{borderColor:  cursoColor,backgroundColor: cursoColor,color:  "#ffffff",}}>{transTxt.btn.continuar.txt}</button>
                        </div>
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    </>);

    }
    
    return (
        <div className="fund-main-course-ok">
            {
                    imgBackType && (imgBackType==="svg")
                    ?
                    <img className="fund-start-b-img" src = {`data:image/svg+xml;base64,${base64_encode(imgBack)}`} alt="Back Ground"/>
                    :(imgBackType!==null)?
                    <img className="fund-start-b-img" src = {`data:image/${imgBackType}+xml;base64,${btoa(imgBack)}`} alt="Back Ground"/>
                    : null
                } 
            <Navbar title={cursoNombre}/>
            
            <div className="fund-ok-question">

                <div className="content-questions" >

                    { disCourse() }
                </div>
                
            </div>
                
        </div>
    )
}

